import { Map } from 'immutable';

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    if (action.data) {
        action.data.forEach((sport) => {
            let item = items.get(sport.id) || Map();

            items = items.set(sport.id, item.merge(sport));
        });
    }

    return state.set('items', items);
}
